module.exports = __webpack_public_path__ + "static/haard-3-12eb532f72bb3c70fd9cbf1386316207.jpg";